import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CategoryStorageType } from '../../../types';
import { CacheLoader } from '../load-storage-controls-data';
var localAnalyticsEnabled;
var localProduct;
var webStorageControlsEnabled;
var localConsentModeEnabled;
var cookiesCacheLoader;
var localStorageCacheLoader;
var sessionStorageCacheLoader;
var loadCache = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(storageType) {
    var _cookiesCacheLoader, _localStorageCacheLoa, _sessionStorageCacheL;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = storageType;
          _context.next = _context.t0 === CategoryStorageType.Cookies ? 3 : _context.t0 === CategoryStorageType.LocalStorage ? 6 : _context.t0 === CategoryStorageType.SessionStorage ? 9 : 12;
          break;
        case 3:
          _context.next = 5;
          return (_cookiesCacheLoader = cookiesCacheLoader) === null || _cookiesCacheLoader === void 0 ? void 0 : _cookiesCacheLoader.loadStorageControlsData();
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.next = 8;
          return (_localStorageCacheLoa = localStorageCacheLoader) === null || _localStorageCacheLoa === void 0 ? void 0 : _localStorageCacheLoa.loadStorageControlsData();
        case 8:
          return _context.abrupt("return", _context.sent);
        case 9:
          _context.next = 11;
          return (_sessionStorageCacheL = sessionStorageCacheLoader) === null || _sessionStorageCacheL === void 0 ? void 0 : _sessionStorageCacheL.loadStorageControlsData();
        case 11:
          return _context.abrupt("return", _context.sent);
        case 12:
          return _context.abrupt("return", undefined);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadCache(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getBscGlobalState = function getBscGlobalState() {
  var _localConsentModeEnab;
  if (localAnalyticsEnabled == null) {
    localAnalyticsEnabled = true;
  }

  // Unless specified, localConsentMode is turned off
  localConsentModeEnabled = (_localConsentModeEnab = localConsentModeEnabled) !== null && _localConsentModeEnab !== void 0 ? _localConsentModeEnab : false;
  return {
    analyticsEnabled: localAnalyticsEnabled,
    product: localProduct,
    webStorageEnabled: webStorageControlsEnabled,
    localConsentMode: localConsentModeEnabled,
    cookiesCacheLoader: cookiesCacheLoader,
    localStorageCacheLoader: localStorageCacheLoader,
    sessionStorageCacheLoader: sessionStorageCacheLoader,
    loadCache: loadCache
  };
};
export var initializeGlobalState = function initializeGlobalState() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$analyticsEnable = _ref2.analyticsEnabled,
    analyticsEnabled = _ref2$analyticsEnable === void 0 ? true : _ref2$analyticsEnable,
    _ref2$product = _ref2.product,
    product = _ref2$product === void 0 ? 'NONE' : _ref2$product,
    _ref2$webStorageEnabl = _ref2.webStorageEnabled,
    webStorageEnabled = _ref2$webStorageEnabl === void 0 ? false : _ref2$webStorageEnabl,
    _ref2$localConsentMod = _ref2.localConsentMode,
    localConsentMode = _ref2$localConsentMod === void 0 ? false : _ref2$localConsentMod;
  localAnalyticsEnabled = analyticsEnabled;
  localProduct = product;
  webStorageControlsEnabled = webStorageEnabled;
  localConsentModeEnabled = localConsentMode;
  cookiesCacheLoader = new CacheLoader(CategoryStorageType.Cookies);
  localStorageCacheLoader = new CacheLoader(CategoryStorageType.LocalStorage);
  sessionStorageCacheLoader = new CacheLoader(CategoryStorageType.SessionStorage);
};
export var testing_overrideGlobalState = function testing_overrideGlobalState(_ref3) {
  var overrideLoadCache = _ref3.loadCache;
  if (overrideLoadCache) {
    loadCache = overrideLoadCache;
  }
};
export var clearGlobalState = function clearGlobalState() {
  localAnalyticsEnabled = undefined;
  localProduct = undefined;
  cookiesCacheLoader = undefined;
  localStorageCacheLoader = undefined;
  sessionStorageCacheLoader = undefined;
};